import React from "react";
import { Row, Col, Badge } from "react-bootstrap";

const InfoCard = ({ title, sender, data, type }) => (
  <div className="card border-0 shadow-sm rounded-4 h-100 mb-0">
    <div className="card-body p-4">
      <div className="mb-4">
        <span className="text-muted fs-12 me-2">{type}:</span>
        <span className="fw-bold text-primary fs-14">{sender}</span>
      </div>
      <Row className="g-4">
        {data.map((item, idx) => (
          <Col key={idx} md={6}>
            <div className="text-muted fs-11 text-uppercase mb-1">
              {item.label}
            </div>
            <div className="fw-bold text-black fs-13">{item.value}</div>
          </Col>
        ))}
      </Row>
    </div>
  </div>
);

const Step3ConfirmTransaction = () => {
  const senderData = [
    { label: "Customer Type", value: "Organization" },
    { label: "ID Type", value: "NRIC (Permanent Resident)" },
    { label: "Nationality", value: "Singapore" },
    { label: "Phone Number", value: "+84 765161894" },
    { label: "Address", value: "24A Bau Cat Street" },
    { label: "ID Number", value: "S1234567A013" },
    { label: "Date of Birth", value: "02/07/1997" },
    {
      label: "KYC Status",
      value: (
        <Badge
          bg="success"
          className="bg-opacity-10 text-success border-0 px-2 py-1"
        >
          Approved
        </Badge>
      ),
    },
  ];

  const beneficiaryData = [
    { label: "Country", value: "Philippines" },
    { label: "Receiving Method", value: "Bank Transfer" },
    { label: "Account Number", value: "0552000003601" },
    { label: "Bank Name", value: "OMNIPAY, INC." },
    { label: "Source of Funds", value: "Salary" },
    { label: "Purpose of Transfer", value: "Payroll" },
  ];

  const summaryData = [
    { label: "Receiving Amount", value: "1 PHP" },
    { label: "Exchange Rate", value: "1 USD = 52.35 PHP" },
    { label: "Send Amount", value: "0.019 USD" },
    { label: "Service Charge", value: "1 USD" },
  ];

  return (
    <div className="mt-4">
      <Row className="g-4">
        <Col lg={4}>
          <InfoCard
            type="Sender"
            sender="SparkMinds Technology Pte Ltd"
            data={senderData}
          />
        </Col>
        <Col lg={4}>
          <InfoCard
            type="Beneficiary"
            sender="SparkMinds"
            data={beneficiaryData}
          />
        </Col>
        <Col lg={4}>
          <div className="card border-0 shadow-sm rounded-4 h-100">
            <div className="card-body p-4 d-flex flex-column">
              <div className="flex-grow-1">
                {summaryData.map((item, idx) => (
                  <div
                    key={idx}
                    className="d-flex justify-content-between mb-3"
                  >
                    <span className="text-muted fs-13">{item.label}</span>
                    <span className="fw-bold text-black fs-13">
                      {item.value}
                    </span>
                  </div>
                ))}
              </div>
              <div className="border-top pt-3 mt-4">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-primary fw-bold fs-14">
                    Paid Amount
                  </span>
                  <span className="text-primary fw-bold fs-16">1.019 USD</span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Step3ConfirmTransaction;
